import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  DropdownArrow,
  DropdownArrowContext,
  getSVGViewBox
} from '../assets';

@Component({
  selector: 'kyc-icon-dropdown-arrow',
  template: DropdownArrow.svg,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownArrowComponent implements SVG2TSDynamic, OnInit {
  public static UUID = 0;
  public baseUrl: string;
  @Input() public height: number | string = DropdownArrow.height;
  @Input() public viewBox: string = getSVGViewBox(DropdownArrow.viewBox);
  @Input() public width: number | string = DropdownArrow.width;
  @Input()
  public set context(ctx: DropdownArrowContext) {
    this.updateContext(ctx);
  }
  public get context() {
    return this._context;
  }

  private _context: DropdownArrowContext = DropdownArrow.contextDefaults;

  constructor(private _ref: ChangeDetectorRef) {}


  public getURLBase(value: string) {
    return `url('${this.getXlinkBase(value)}')`;
  }

  public getXlinkBase(value: string) {
    return `${this.baseUrl}${value}`;
  }

  public ngOnInit() {
    this.baseUrl = window.location.href.replace(window.location.hash, '');
    this.context.uuid = DropdownArrowComponent.UUID++;
  }

  public updateContext(ctx: any) {
    this._context = Object.assign({}, this._context ? this._context : DropdownArrow.contextDefaults, ctx);
    this._ref.markForCheck();
  }
}
